import { FieldParser } from ".";
import { isNullOrUndefined, safeISODateConversion, safeNumberConversion } from "./utils";

export const returnNull = (value: unknown): string =>
  isNullOrUndefined(value) ? '#N/A' : String(value);

export const stringParser: FieldParser<string> = (value) =>
  isNullOrUndefined(value) ? null : String(value);

export const numberParser: FieldParser<number> = (value) =>
  safeNumberConversion(value);

export const percentParser: FieldParser<number> = (value) => {
  const num = safeNumberConversion(value);
  return num !== null ? num / 100 : null;
};

export const booleanParser: FieldParser<boolean> = (value) =>
  String(value).toLowerCase() === 'true';

export const dateParser: FieldParser<string> = (value) =>
  safeISODateConversion(value);

export const listParser = (separator: string): FieldParser<string[]> => {
  return (value) => {
    if (isNullOrUndefined(value)) return null;
    return String(value).split(separator).map(item => item.trim());
  };
};

export const semicolonListParser: FieldParser<string> = (value) => {
  if (isNullOrUndefined(value)) return null;
  return String(value).split(',').map(v => v.trim()).join(';');
};